import type { Order as IColumnOrder, OrderType } from 'api/models';
import { ColumnOrder as ColumnOrderType } from 'components/organisms/grid-custom-column';

export class ColumnOrder implements IColumnOrder {
  key: string;

  viewId: number;

  columnOrder: ColumnOrderType[];

  orderType: OrderType;

  createdAt?: number;

  constructor(order: IColumnOrder) {
    this.key = order.key;
    this.viewId = order.viewId;
    this.columnOrder = order.columnOrder;
    this.orderType = order.orderType;
    this.createdAt = order.createdAt;
  }
}
